import {createBrowserRouter, createRoutesFromElements, Route} from 'react-router-dom'
import {PrivateRoute} from '@route-guards/private-route'
import {PublicRoute} from '@route-guards/public-route'
import {PublicLayout} from '@layouts/public-layout'
import {PrivateLayout} from '@layouts/private-layout'
import {routes} from '@utilities/constants/routes.tsx'
import {RouteErrorElement} from '@components/commons/route-error-element'
import {ImpersonateRouteGuard} from '@route-guards/impersonate-route-guard'

export const router = createBrowserRouter(
    createRoutesFromElements(
        <Route path="/" element={<ImpersonateRouteGuard />}>
            <Route element={<PrivateRoute />}>
                <Route element={<PrivateLayout />} errorElement={<RouteErrorElement />}>
                    <Route {...routes.ASSIGNMENT} />
                    <Route {...routes.HOME} />
                    <Route {...routes.PAYMENTS} />
                    <Route {...routes.SETTINGS} />
                    <Route {...routes.INSIGHTS} />
                    <Route {...routes.NOT_FOUND} />
                </Route>
                <Route {...routes.GOOGLE_AUTH_CALLBACK} />
                <Route {...routes.LINK_AIRBNB_ACCOUNT} />
                <Route {...routes.LINK_AIRBNB_ACCOUNT_CONFIRM} />
                <Route {...routes.SSO_REDIRECT} />
                <Route {...routes.MARKETS_CONFIGURATION} />
                <Route {...routes.FLOOR_PLAN_OPT_IN} />
            </Route>

            <Route element={<PublicRoute />}>
                <Route element={<PublicLayout />} errorElement={<RouteErrorElement />}>
                    <Route {...routes.CREATE_ACCOUNT} />
                    <Route {...routes.FORGOT_PASSWORD} />
                    <Route {...routes.RESET_PASSWORD} />
                    <Route {...routes.LOGIN} />
                    <Route {...routes.NOT_FOUND} />
                </Route>
            </Route>

            <Route {...routes.CHANGE_EMAIL_VERIFY} />
            <Route {...routes.PUBLIC_LANDING} />
            <Route {...routes.PRIVACY_POLICY} />
            <Route {...routes.NOT_FOUND} />
        </Route>
    )
)
